import React from "react";
import { useSelector } from "react-redux";
import "antd/dist/reset.css";

import ProgressBar from '@atlaskit/progress-bar';

const Loading = () => {
  const loading = useSelector((state) => state.message.loading);
  const loadingMessage = useSelector((state) => state.message.loadingMessage);

  return (
    <>
      {loading && (
        <ProgressBar isIndeterminate />
      )}
    </>
  );
};
export default Loading;
